(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pants-product-tabs"] && !Shopify.designMode) return;
  try {
    
  class PantsProductTabs {
    constructor(section) {
      this.section = section;
      this.template = section.querySelector('[data-pants-product-description]');
      this.destination = section.querySelector('[data-pants-dynamic-tabs]');
      this.render();
    }

    render() {
      if (!this.template || !this.destination) return;
      const source = this.template.content.cloneNode(true);
      const groups = [];
      let activeGroup;

      Array.from(source.childNodes).forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H5' && groups.length < 2) {
          activeGroup = { content: document.createDocumentFragment(), title: node.textContent.trim() };
          groups.push(activeGroup);
        } else if (activeGroup) {
          activeGroup.content.append(node.cloneNode(true));
        }
      });

      if (!groups.length && source.childNodes.length) {
        groups.push({ content: source, title: this.section.dataset.descriptionTitle });
      }

      groups.forEach((group, index) => {
        if (!group.title) return;
        const details = document.createElement('details');
        const summary = document.createElement('summary');
        const icon = document.createElement('span');
        const content = document.createElement('div');
        details.className = 'pants-product-tabs__item';
        summary.className = 'pants-product-tabs__summary';
        icon.className = 'pants-product-tabs__icon';
        icon.setAttribute('aria-hidden', 'true');
        content.className = 'pants-product-tabs__content rte';
        summary.append(group.title, icon);
        content.append(group.content);
        details.append(summary, content);
        if (index === 0) details.open = true;
        this.destination.append(details);
      });
    }
  }

  document.querySelectorAll('[data-pants-product-tabs]').forEach((section) => new PantsProductTabs(section));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sizechart-measurement-guide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sizechart-guide]').forEach((section) => {
    const dialog = section.querySelector('[data-sizechart-dialog]');
    const openButton = section.querySelector('[data-sizechart-open]');
    const closeButton = section.querySelector('[data-sizechart-close]');
    if (!dialog || !openButton || !closeButton) return;
    openButton.addEventListener('click', () => dialog.showModal());
    closeButton.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sizechart-product-tabs"] && !Shopify.designMode) return;
  try {
    
  class SizechartProductTabs {
    constructor(section) {
      this.section = section;
      this.template = section.querySelector('[data-sizechart-product-description]');
      this.destination = section.querySelector('[data-sizechart-dynamic-tabs]');
      this.allowedTitles = ['Beschreibung', 'Material & Pflege', 'Passform & Größenhinweis'];
      this.render();
    }

    render() {
      if (!this.template || !this.destination) return;
      const source = this.template.content.cloneNode(true);
      const groups = [];
      let activeGroup;

      Array.from(source.childNodes).forEach((node) => {
        const isHeading = node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H2';
        const title = isHeading ? node.textContent.trim() : '';
        if (isHeading && this.allowedTitles.includes(title)) {
          activeGroup = { content: document.createDocumentFragment(), title };
          groups.push(activeGroup);
        } else if (activeGroup) {
          activeGroup.content.append(node.cloneNode(true));
        }
      });

      if (!groups.length && source.childNodes.length) {
        groups.push({ content: source, title: this.section.dataset.descriptionTitle });
      }

      groups.forEach((group, index) => {
        const hasContent = Array.from(group.content.childNodes).some((node) => node.textContent.trim() || node.nodeType === Node.ELEMENT_NODE);
        if (!group.title || !hasContent) return;
        const details = document.createElement('details');
        const summary = document.createElement('summary');
        const title = document.createElement('span');
        const icon = document.createElement('span');
        const content = document.createElement('div');
        details.className = 'sizechart-product-tabs__item';
        summary.className = 'sizechart-product-tabs__summary';
        title.textContent = group.title;
        icon.className = 'sizechart-product-tabs__icon';
        icon.setAttribute('aria-hidden', 'true');
        content.className = 'sizechart-product-tabs__content rte';
        summary.append(title, icon);
        content.append(group.content);
        details.append(summary, content);
        if (index === 0) details.open = true;
        this.destination.append(details);
      });
    }
  }

  document.querySelectorAll('[data-sizechart-product-tabs]').forEach((section) => new SizechartProductTabs(section));

  } catch(e) { console.error(e); }
})();
})();
